/* チャットウィジェット位置調整（bottom-navigation との重なり回避） */
(function() {
  var bottomNavHeight = 48;
  var adjustments = [
    { id: 'AppleBusinessChat', bottom: (bottomNavHeight - 4) + 'px' },
    { id: 'dummy-chat-button-iframe', bottom: bottomNavHeight + 'px', right: '12px' },
    { id: 'admin-bar-iframe', bottom: '30px' }
  ];
  function applyAdjustments() {
    adjustments.forEach(function(adj) {
      var el = document.getElementById(adj.id);
      if (!el) return;
      el.style.bottom = adj.bottom;
      if (adj.right) el.style.right = adj.right;
    });
  }
  applyAdjustments();
  new MutationObserver(applyAdjustments).observe(document.body, { childList: true, subtree: true });
})();

/* 画像付きテキスト列: キャッシュに残った旧CTA文言の補正 */
(function() {
  var labelMap = {
    'フレーク購入ページへ': 'フレークを見る',
    'ミンチ購入ページへ': 'ミンチを見る',
    'スティック購入ページへ': 'スティックを見る'
  };

  function normalizeLabel(text) {
    return (text || '').replace(/\s+/g, '').trim();
  }

  function updateFeatureColumnLabels() {
    document.querySelectorAll('.feature-columns__cta a').forEach(function(link) {
      var oldLabel = normalizeLabel(link.textContent);
      var newLabel = labelMap[oldLabel];

      if (!newLabel) {
        return;
      }

      var icon = link.querySelector('svg, .icon-fa');
      link.textContent = newLabel;

      if (icon) {
        var iconWrap = document.createElement('span');
        iconWrap.style.paddingLeft = '0.25em';
        iconWrap.appendChild(icon);
        link.appendChild(iconWrap);
      }

      if (link.getAttribute('aria-label') === oldLabel) {
        link.setAttribute('aria-label', newLabel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateFeatureColumnLabels);
  } else {
    updateFeatureColumnLabels();
  }
})();

/* デスクトップ: スクロール後のカート未完了リマインダー */
(function() {
  var guide = document.querySelector('.desktop-cart-guide');
  if (!guide) return;

  var desktopQuery = window.matchMedia('(min-width: 750px)');
  var scrollThreshold = 180;
  var ticking = false;

  function cartPopupVisible() {
    var popup = document.querySelector('[data-cart-popup-wrapper]');
    return !!(popup && !popup.classList.contains('cart-popup-wrapper--hidden') && !popup.classList.contains('critical-hidden'));
  }

  function productGuidanceVisible() {
    return !!document.querySelector('[data-product-cart-guidance]:not(.product-cart-guidance--hidden)');
  }

  function shouldShowGuide() {
    return desktopQuery.matches
      && window.scrollY > scrollThreshold
      && !guide.classList.contains('mobile-cart-guide--hidden')
      && !cartPopupVisible()
      && !productGuidanceVisible();
  }

  function syncGuide() {
    ticking = false;
    guide.classList.toggle('desktop-cart-guide--visible', shouldShowGuide());
  }

  function requestSyncGuide() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncGuide);
  }

  window.addEventListener('scroll', requestSyncGuide, { passive: true });
  window.addEventListener('resize', requestSyncGuide);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', requestSyncGuide);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(requestSyncGuide);
  }

  new MutationObserver(requestSyncGuide).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'hidden', 'style']
  });

  requestSyncGuide();
})();

/* ニュースリスト トグル — ボタンが無ければ自動生成 */
(function() {
  var newsSection = document.querySelector('.news-section');
  if (!newsSection) return;

  var newsList = newsSection.querySelector('.news-list');
  if (!newsList) return;

  var btn = document.getElementById('toggle-list');
  if (!btn) {
    btn = document.createElement('button');
    btn.id = 'toggle-list';
    btn.className = 'toggle-btn';
    btn.innerHTML = 'もっと見る <svg class="icon-fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="1em" height="1em" aria-hidden="true"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>';
    var container = newsSection.querySelector('.news-container');
    if (container) {
      container.after(btn);
    } else {
      newsSection.appendChild(btn);
    }
  }

  btn.addEventListener('click', function() {
    if (newsList.classList.contains('expanded')) {
      newsList.classList.remove('expanded');
      this.innerHTML = 'もっと見る <svg class="icon-fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="1em" height="1em" aria-hidden="true"><path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/></svg>';
    } else {
      newsList.classList.add('expanded');
      this.innerHTML = '閉じる <svg class="icon-fa" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="1em" height="1em" aria-hidden="true"><path d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"/></svg>';
    }
  });
})();

/* 最新のおしらせ: ページ高さを変えない一覧パネル */
(function() {
  var openSelector = '[data-latest-notices-open]';
  var dialogSelector = '[data-latest-notices-dialog]';
  var closeSelector = '[data-latest-notices-close]';
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');
  var lockedScrollY = 0;
  var scrollLocked = false;
  var previousBodyOverflow = '';
  var previousHtmlOverflow = '';
  var previousScrollRestoration = null;

  function getOpenDialog() {
    return document.querySelector(dialogSelector + '.is-open');
  }

  function getFocusable(dialog) {
    return Array.prototype.slice.call(dialog.querySelectorAll(focusableSelector)).filter(function(element) {
      return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    });
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function resetDialogAnimationStyles(dialog) {
    var panel = dialog.querySelector('[data-latest-notices-panel]');
    var backdrop = dialog.querySelector('.latest-notices-dialog__backdrop');

    clearTimeout(dialog._latestNoticesOpenTimer);
    clearTimeout(dialog._latestNoticesCloseTimer);
    clearTimeout(dialog._latestNoticesUnlockTimer);
    dialog.style.pointerEvents = '';

    if (panel) {
      panel.style.transition = '';
      panel.style.transform = '';
      panel.style.opacity = '';
    }

    if (backdrop) {
      backdrop.style.transition = '';
      backdrop.style.opacity = '';
    }
  }

  function setDialogMotion(dialog, opener) {
    var panel = dialog.querySelector('[data-latest-notices-panel]');
    if (!panel || !opener) return;

    resetDialogAnimationStyles(dialog);
    dialog.classList.add('is-measuring');
    panel.style.removeProperty('--latest-notices-dialog-x');
    panel.style.removeProperty('--latest-notices-dialog-y');
    panel.style.removeProperty('--latest-notices-dialog-scale-x');
    panel.style.removeProperty('--latest-notices-dialog-scale-y');

    var source = opener.closest('.latest-notices__summary') || opener;
    var sourceRect = source.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();

    dialog.classList.remove('is-measuring');

    if (!sourceRect.width || !sourceRect.height || !panelRect.width || !panelRect.height) return;

    var sourceCenterX = sourceRect.left + sourceRect.width / 2;
    var sourceCenterY = sourceRect.top + sourceRect.height / 2;
    var panelCenterX = panelRect.left + panelRect.width / 2;
    var panelCenterY = panelRect.top + panelRect.height / 2;
    var scaleX = clamp(sourceRect.width / panelRect.width, .82, .98);
    var scaleY = clamp(sourceRect.height / panelRect.height, .32, .98);

    panel.style.setProperty('--latest-notices-dialog-x', (sourceCenterX - panelCenterX) + 'px');
    panel.style.setProperty('--latest-notices-dialog-y', (sourceCenterY - panelCenterY) + 'px');
    panel.style.setProperty('--latest-notices-dialog-scale-x', scaleX);
    panel.style.setProperty('--latest-notices-dialog-scale-y', scaleY);

    return {
      x: sourceCenterX - panelCenterX,
      y: sourceCenterY - panelCenterY,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }

  function prepareDialogOpenAnimation(dialog, motion) {
    var panel = dialog.querySelector('[data-latest-notices-panel]');
    var backdrop = dialog.querySelector('.latest-notices-dialog__backdrop');
    if (!panel || !motion) return;

    clearTimeout(dialog._latestNoticesOpenTimer);
    panel.style.transition = 'none';
    panel.style.transform = 'translate3d(' + motion.x + 'px, ' + motion.y + 'px, 0) scale(' + motion.scaleX + ', ' + motion.scaleY + ')';
    panel.style.opacity = '.86';

    if (backdrop) {
      backdrop.style.transition = 'none';
      backdrop.style.opacity = '0';
    }

    panel.offsetHeight;
    if (backdrop) backdrop.offsetHeight;
  }

  function playDialogOpenAnimation(dialog) {
    var panel = dialog.querySelector('[data-latest-notices-panel]');
    var backdrop = dialog.querySelector('.latest-notices-dialog__backdrop');
    if (!panel) return;

    window.requestAnimationFrame(function() {
      dialog.classList.add('is-open');
      panel.style.transition = 'transform .32s cubic-bezier(.2, .78, .18, 1), opacity .2s ease, box-shadow .32s cubic-bezier(.2, .78, .18, 1)';
      panel.style.transform = 'translate3d(0, 0, 0) scale(1)';
      panel.style.opacity = '1';

      if (backdrop) {
        backdrop.style.transition = 'opacity .22s ease';
        backdrop.style.opacity = '1';
      }

      var focusable = getFocusable(dialog);
      var firstClose = dialog.querySelector('.latest-notices-dialog__close');
      (firstClose || focusable[0] || dialog).focus();

      dialog._latestNoticesOpenTimer = setTimeout(function() {
        if (!dialog.classList.contains('is-open')) return;
        panel.style.transition = '';
        panel.style.transform = '';
        panel.style.opacity = '';

        if (backdrop) {
          backdrop.style.transition = '';
          backdrop.style.opacity = '';
        }
      }, 360);
    });
  }

  function playDialogCloseAnimation(dialog, motion, onAfterFade, onComplete) {
    var panel = dialog.querySelector('[data-latest-notices-panel]');
    var backdrop = dialog.querySelector('.latest-notices-dialog__backdrop');

    if (!panel || !motion) {
      onAfterFade();
      onComplete();
      return;
    }

    dialog.style.pointerEvents = '';
    panel.style.transition = 'none';
    panel.style.transform = 'translate3d(0, 0, 0) scale(1)';
    panel.style.opacity = '1';

    if (backdrop) {
      backdrop.style.transition = 'none';
      backdrop.style.opacity = '1';
    }

    panel.offsetHeight;
    if (backdrop) backdrop.offsetHeight;

    window.requestAnimationFrame(function() {
      panel.style.transition = 'transform .4s cubic-bezier(.2, .78, .18, 1), opacity .2s ease, box-shadow .4s cubic-bezier(.2, .78, .18, 1)';
      panel.style.transform = 'translate3d(' + motion.x + 'px, ' + motion.y + 'px, 0) scale(' + motion.scaleX + ', ' + motion.scaleY + ')';
      panel.style.opacity = '0';

      if (backdrop) {
        backdrop.style.transition = 'opacity .2s ease';
        backdrop.style.opacity = '0';
      }

      dialog._latestNoticesUnlockTimer = setTimeout(function() {
        dialog.style.pointerEvents = 'none';
        onAfterFade();
      }, 220);
      dialog._latestNoticesCloseTimer = setTimeout(onComplete, 440);
    });
  }

  function lockScroll() {
    if (scrollLocked) return;

    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    previousBodyOverflow = document.body.style.overflow;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousScrollRestoration = null;
    if ('scrollRestoration' in window.history) {
      previousScrollRestoration = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
    }
    document.body.classList.add('latest-notices-dialog-open');
    document.documentElement.classList.add('latest-notices-dialog-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    scrollLocked = true;
  }

  function unlockScroll() {
    if (!scrollLocked) return;

    document.body.classList.remove('latest-notices-dialog-open');
    document.documentElement.classList.remove('latest-notices-dialog-open');
    document.body.style.overflow = previousBodyOverflow;
    document.documentElement.style.overflow = previousHtmlOverflow;
    window.scrollTo(0, lockedScrollY);
    if (previousScrollRestoration !== null) {
      window.history.scrollRestoration = previousScrollRestoration;
      previousScrollRestoration = null;
    }
    scrollLocked = false;
  }

  function closeDialog(dialog, options) {
    if (!dialog || !dialog.classList.contains('is-open')) return;

    var shouldReturnFocus = !options || options.returnFocus !== false;
    var opener = dialog._latestNoticesOpener;
    clearTimeout(dialog._latestNoticesBackTimer);
    dialog.dataset.latestNoticesHistory = 'false';
    var motion = setDialogMotion(dialog, opener);

    playDialogCloseAnimation(dialog, motion, unlockScroll, function() {
      resetDialogAnimationStyles(dialog);
      dialog.classList.remove('is-open');
      dialog.hidden = true;
      restoreDialog(dialog);

      if (shouldReturnFocus && opener && document.contains(opener)) {
        opener.focus();
      }
    });
  }

  function moveDialogToBody(dialog) {
    if (!dialog._latestNoticesPlaceholder) {
      dialog._latestNoticesPlaceholder = document.createComment('latest-notices-dialog');
      dialog.parentNode.insertBefore(dialog._latestNoticesPlaceholder, dialog);
    }

    if (dialog.parentNode !== document.body) {
      document.body.appendChild(dialog);
    }
  }

  function restoreDialog(dialog) {
    var placeholder = dialog._latestNoticesPlaceholder;
    if (!placeholder || !placeholder.parentNode || dialog.parentNode !== document.body) return;

    placeholder.parentNode.insertBefore(dialog, placeholder.nextSibling);
  }

  function closeDialogFromHistory(dialog) {
    closeDialog(dialog, {
      returnFocus: dialog.dataset.latestNoticesReturnFocus !== 'false'
    });
  }

  function requestCloseDialog(dialog, returnFocus) {
    if (!dialog) return;
    dialog.dataset.latestNoticesReturnFocus = returnFocus === false ? 'false' : 'true';

    if (dialog.dataset.latestNoticesHistory === 'true') {
      window.history.back();
      clearTimeout(dialog._latestNoticesBackTimer);
      dialog._latestNoticesBackTimer = setTimeout(function() {
        closeDialogFromHistory(dialog);
      }, 360);
      return;
    }

    closeDialog(dialog, { returnFocus: returnFocus !== false });
  }

  function openDialog(opener) {
    var dialogId = opener.getAttribute('aria-controls');
    var dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!dialog) return;

    var currentOpenDialog = getOpenDialog();
    if (currentOpenDialog && currentOpenDialog !== dialog) {
      closeDialog(currentOpenDialog, { returnFocus: false });
    }

    clearTimeout(dialog._latestNoticesCloseTimer);
    clearTimeout(dialog._latestNoticesUnlockTimer);
    dialog._latestNoticesOpener = opener;
    dialog.dataset.latestNoticesReturnFocus = 'true';
    lockScroll();
    moveDialogToBody(dialog);
    dialog.hidden = false;
    var motion = setDialogMotion(dialog, opener);
    prepareDialogOpenAnimation(dialog, motion);

    try {
      window.history.pushState({ latestNoticesDialog: dialog.id }, '', window.location.href);
      dialog.dataset.latestNoticesHistory = 'true';
    } catch (error) {
      dialog.dataset.latestNoticesHistory = 'false';
    }

    playDialogOpenAnimation(dialog);
  }

  document.addEventListener('click', function(event) {
    var opener = event.target.closest(openSelector);
    if (opener) {
      event.preventDefault();
      openDialog(opener);
      return;
    }

    var closer = event.target.closest(closeSelector);
    if (!closer) return;

    var dialog = closer.closest(dialogSelector);
    if (!dialog) return;

    event.preventDefault();
    requestCloseDialog(dialog, true);
  });

  document.addEventListener('keydown', function(event) {
    var dialog = getOpenDialog();
    if (!dialog) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      requestCloseDialog(dialog, true);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusable(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('popstate', function() {
    var dialog = getOpenDialog();
    if (!dialog || dialog.dataset.latestNoticesHistory !== 'true') return;
    closeDialogFromHistory(dialog);
  });
})();

/* IP return navigation lives in ip-navigation.js. */

/* ヘッダー操作メニュー */
(function() {
  var catalogMenu = document.querySelector('.header-catalog-menu');
  var catalogToggle = catalogMenu ? catalogMenu.querySelector('.header-catalog-menu__toggle') : null;
  var catalogDropdown = document.getElementById('HeaderCatalogDropdown');
  var accountMenu = document.querySelector('.header-account-menu');
  var accountToggle = accountMenu ? accountMenu.querySelector('.header-account-menu__toggle') : null;
  var accountDropdown = document.getElementById('HeaderAccountDropdown');
  var mobileToggle = document.querySelector('.js-mobile-nav-toggle');
  var mobileMenu = document.querySelector('.mobile-nav-wrapper');
  var mobileNav = document.getElementById('MobileNav');
  var mobileCloseButton = mobileMenu ? mobileMenu.querySelector('[data-mobile-nav-close]') : null;
  var cartLink = document.querySelector('[data-header-cart]');
  var pageContainer = document.getElementById('PageContainer');
  var siteHeader = document.querySelector('.site-header');
  /* ヘッダーの1列化閾値(custom-base.cssの min-width:1000px と揃える) */
  var mobileHeaderPanelQuery = window.matchMedia('(max-width: 999px)');
  var headerPanelAnimationFrame = null;
  var headerPanelAnimationToken = 0;
  var headerSection = document.getElementById('shopify-section-header');

  function getHeaderFocusTrap() {
    var a11y = window.slate && window.slate.a11y;
    if (!headerSection || !a11y) return null;
    if (typeof a11y.trapFocus !== 'function' || typeof a11y.removeTrapFocus !== 'function') {
      return null;
    }
    return a11y;
  }

  function setToggleState(toggle, isOpen) {
    if (!toggle) return;
    var label = isOpen ? toggle.getAttribute('data-header-toggle-close-label') : toggle.getAttribute('data-header-toggle-label');
    if (label) {
      toggle.setAttribute('aria-label', label);
    }
    toggle.setAttribute('aria-expanded', String(isOpen));
  }

  function isMobileNavOpen() {
    return mobileMenu && mobileMenu.classList.contains('js-menu--is-open');
  }

  function getOpenHeaderPanel() {
    if (catalogDropdown && !catalogDropdown.hidden) {
      return catalogDropdown;
    }
    if (accountDropdown && !accountDropdown.hidden) {
      return accountDropdown;
    }
    if (isMobileNavOpen()) {
      return mobileMenu;
    }
    return null;
  }

  function showHeaderPanel(panel) {
    if (!panel) return;
    headerPanelAnimationToken += 1;
    var token = headerPanelAnimationToken;
    if (headerPanelAnimationFrame) {
      window.cancelAnimationFrame(headerPanelAnimationFrame);
    }

    panel.classList.remove('is-header-panel-visible');
    panel.offsetHeight;
    headerPanelAnimationFrame = window.requestAnimationFrame(function() {
      headerPanelAnimationFrame = null;
      if (token !== headerPanelAnimationToken || panel !== getOpenHeaderPanel()) return;
      panel.classList.add('is-header-panel-visible');
    });
  }

  function hideHeaderPanel(panel) {
    if (!panel) return;
    headerPanelAnimationToken += 1;
    if (headerPanelAnimationFrame) {
      window.cancelAnimationFrame(headerPanelAnimationFrame);
      headerPanelAnimationFrame = null;
    }
    panel.classList.remove('is-header-panel-visible');
  }

  function updateHeaderPanelOffset() {
    if (!pageContainer) return;

    var panel = getOpenHeaderPanel();
    if (!panel || !mobileHeaderPanelQuery.matches) {
      if (!isMobileNavOpen()) {
        pageContainer.setAttribute('style', '');
      }
      return;
    }

    var offset = Math.ceil(panel.getBoundingClientRect().height + 12);
    pageContainer.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
  }

  function findMobileDropdown(target) {
    if (!mobileMenu || !target) return null;
    return Array.prototype.slice.call(mobileMenu.querySelectorAll('.mobile-nav__dropdown')).filter(function(dropdown) {
      return dropdown.getAttribute('data-parent') === target;
    })[0] || null;
  }

  function findMobileSubmenuToggle(target) {
    if (!mobileMenu || !target) return null;
    return Array.prototype.slice.call(mobileMenu.querySelectorAll('.js-toggle-submenu')).filter(function(button) {
      return button.getAttribute('data-target') === target;
    })[0] || null;
  }

  function getDirectMobileSubmenuToggle(item) {
    if (!item) return null;
    return Array.prototype.slice.call(item.children).filter(function(child) {
      return child.classList &&
        child.classList.contains('js-toggle-submenu') &&
        !child.classList.contains('mobile-nav__return-btn');
    })[0] || null;
  }

  function closeMobileSubmenu(button) {
    if (!button) return;

    button.classList.remove('is-active');
    button.setAttribute('aria-expanded', 'false');

    var dropdown = findMobileDropdown(button.getAttribute('data-target'));
    if (dropdown) {
      dropdown.querySelectorAll('.js-toggle-submenu.is-active').forEach(function(childButton) {
        closeMobileSubmenu(childButton);
      });
    }
  }

  function closeMobileSubmenuSiblings(button) {
    var list = button ? button.closest('ul') : null;
    if (!list) return;

    Array.prototype.slice.call(list.children).forEach(function(item) {
      var sibling = getDirectMobileSubmenuToggle(item);
      if (sibling && sibling !== button && sibling.classList.contains('is-active')) {
        closeMobileSubmenu(sibling);
      }
    });
  }

  function updateMobileMenuHeight() {
    if (!mobileMenu) return;
    mobileMenu.style.height = '';
    updateHeaderPanelOffset();
  }

  function normalizePathname(pathname) {
    var normalized = pathname.replace(/\/+$/, '');
    return normalized || '/';
  }

  function isMobileSamePageAnchorLink(link) {
    if (!mobileHeaderPanelQuery.matches || !link) return false;

    var href = link.getAttribute('href');
    if (!href) return false;

    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return false;
    }

    return url.hash.length > 1 &&
      url.origin === window.location.origin &&
      normalizePathname(url.pathname) === normalizePathname(window.location.pathname);
  }

  function toggleMobileSubmenu(button) {
    if (!button || !mobileMenu) return;

    mobileMenu.classList.remove('sub-nav--is-open', 'third-nav--is-open');

    if (button.classList.contains('is-active')) {
      closeMobileSubmenu(button);
    } else {
      closeMobileSubmenuSiblings(button);
      button.classList.add('is-active');
      button.setAttribute('aria-expanded', 'true');
    }

    updateMobileMenuHeight();
  }

  function resetMobileSubmenus() {
    if (!mobileMenu || !mobileNav) return;
    mobileMenu.querySelectorAll('.js-toggle-submenu.is-active').forEach(function(button) {
      closeMobileSubmenu(button);
    });
    mobileMenu.querySelectorAll('.js-toggle-submenu:not(.mobile-nav__return-btn)').forEach(function(button) {
      button.setAttribute('aria-expanded', 'false');
    });
    mobileMenu.querySelectorAll('.mobile-nav__dropdown.is-closing').forEach(function(dropdown) {
      dropdown.classList.remove('is-closing');
    });
    mobileMenu.classList.remove('sub-nav--is-open', 'third-nav--is-open');
    mobileMenu.style.height = '';
  }

  function closeMobileNav(focusTarget) {
    if (!isMobileNavOpen()) return;

    if (mobileMenu) {
      hideHeaderPanel(mobileMenu);
      mobileMenu.classList.remove('js-menu--is-open');
      mobileMenu.style.transform = '';
      resetMobileSubmenus();
    }

    if (mobileToggle) {
      mobileToggle.classList.add('mobile-nav--open');
      mobileToggle.classList.remove('mobile-nav--close');
    }

    setToggleState(mobileToggle, false);

    var focusTrap = getHeaderFocusTrap();
    if (focusTrap) {
      focusTrap.removeTrapFocus({ container: headerSection });
    }

    if (focusTarget) {
      focusTarget.focus();
    }

    updateHeaderPanelOffset();
  }

  function openMobileNav() {
    if (!mobileMenu || !mobileToggle) return;

    closeCatalog(false);
    closeAccount(false);

    mobileMenu.style.transform = '';
    resetMobileSubmenus();
    mobileMenu.classList.add('js-menu--is-open');
    mobileToggle.classList.add('mobile-nav--close');
    mobileToggle.classList.remove('mobile-nav--open');
    setToggleState(mobileToggle, true);
    showHeaderPanel(mobileMenu);
    updateHeaderPanelOffset();

    var focusTrap = getHeaderFocusTrap();
    if (focusTrap) {
      focusTrap.trapFocus({ container: headerSection, elementToFocus: mobileToggle });
    }
  }

  function toggleMobileNav(event) {
    if (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    if (isMobileNavOpen()) {
      closeMobileNav(false);
    } else {
      openMobileNav();
    }
  }

  function closeCatalog(focusToggle) {
    if (!catalogToggle || !catalogDropdown) return;

    hideHeaderPanel(catalogDropdown);
    catalogDropdown.hidden = true;
    setToggleState(catalogToggle, false);
    updateHeaderPanelOffset();

    if (focusToggle && catalogToggle) {
      catalogToggle.focus();
    }
  }

  function openCatalog() {
    closeAccount(false);
    closeMobileNav(catalogToggle);
    catalogDropdown.hidden = false;
    setToggleState(catalogToggle, true);
    showHeaderPanel(catalogDropdown);
    updateHeaderPanelOffset();
  }

  function closeAccount(focusToggle) {
    if (!accountToggle || !accountDropdown) return;

    hideHeaderPanel(accountDropdown);
    accountDropdown.hidden = true;
    setToggleState(accountToggle, false);
    updateHeaderPanelOffset();

    if (focusToggle) {
      accountToggle.focus();
    }
  }

  function openAccount() {
    closeCatalog(false);
    closeMobileNav(accountToggle);
    accountDropdown.hidden = false;
    setToggleState(accountToggle, true);
    showHeaderPanel(accountDropdown);
    updateHeaderPanelOffset();
  }

  function closeHeaderMenus(focusTarget) {
    closeCatalog(false);
    closeAccount(false);
    closeMobileNav(focusTarget);
  }

  if (catalogToggle && catalogDropdown) {
    setToggleState(catalogToggle, !catalogDropdown.hidden);

    catalogToggle.addEventListener('click', function(event) {
      event.preventDefault();
      if (!catalogDropdown.hidden) {
        closeCatalog(false);
      } else {
        openCatalog();
      }
    });

    var catalogCloseButton = catalogMenu.querySelector('[data-header-catalog-close]');
    if (catalogCloseButton) {
      catalogCloseButton.addEventListener('click', function() {
        closeCatalog(true);
      });
    }

    catalogMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        if (isMobileSamePageAnchorLink(this)) {
          updateHeaderPanelOffset();
          return;
        }

        closeCatalog(false);
        closeAccount(false);
        closeMobileNav(false);
        updateHeaderPanelOffset();
      });
    });
  }

  if (accountToggle && accountDropdown) {
    setToggleState(accountToggle, !accountDropdown.hidden);

    accountToggle.addEventListener('click', function(event) {
      event.preventDefault();
      if (accountDropdown.hidden) {
        openAccount();
      } else {
        closeAccount(false);
      }
    });

    var accountCloseButton = accountDropdown.querySelector('[data-header-account-close]');
    if (accountCloseButton) {
      accountCloseButton.addEventListener('click', function() {
        closeAccount(true);
      });
    }

    accountDropdown.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        var title = this.querySelector('.account-menu-card__title') || this;
        this.classList.add('is-loading');
        this.dataset.originalLabel = title.textContent;
        title.textContent = '読み込み中';
      });
    });
  }

  if (mobileToggle) {
    setToggleState(mobileToggle, isMobileNavOpen());
    mobileToggle.addEventListener('click', toggleMobileNav, true);
  }

  if (mobileCloseButton) {
    mobileCloseButton.addEventListener('click', function() {
      closeMobileNav(mobileToggle);
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function(event) {
      var submenuToggle = event.target.closest('.js-toggle-submenu');
      if (!submenuToggle || !mobileMenu.contains(submenuToggle)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (submenuToggle.classList.contains('mobile-nav__return-btn')) {
        var currentDropdown = submenuToggle.closest('.mobile-nav__dropdown');
        closeMobileSubmenu(findMobileSubmenuToggle(currentDropdown ? currentDropdown.getAttribute('data-parent') : null));
      } else {
        toggleMobileSubmenu(submenuToggle);
      }
    }, true);

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        if (isMobileSamePageAnchorLink(this)) {
          updateHeaderPanelOffset();
          return;
        }

        closeHeaderMenus(false);
      });
    });
  }

  if (cartLink) {
    cartLink.addEventListener('click', function() {
      closeHeaderMenus(false);
    });
  }

  document.addEventListener('click', function(event) {
    if (
      (catalogMenu && catalogMenu.contains(event.target)) ||
      (accountMenu && accountMenu.contains(event.target)) ||
      (mobileToggle && mobileToggle.contains(event.target)) ||
      (mobileMenu && mobileMenu.contains(event.target))
    ) {
      return;
    }

    if (mobileHeaderPanelQuery.matches) {
      return;
    }

    closeCatalog(false);
    closeAccount(false);
    closeMobileNav(false);
    updateHeaderPanelOffset();
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      var focusTarget = null;
      if (catalogDropdown && !catalogDropdown.hidden) {
        focusTarget = catalogToggle;
      } else if (accountDropdown && !accountDropdown.hidden) {
        focusTarget = accountToggle;
      } else if (isMobileNavOpen()) {
        focusTarget = mobileToggle;
      }
      closeHeaderMenus(focusTarget);
      updateHeaderPanelOffset();
    }
  });

  window.addEventListener('resize', updateHeaderPanelOffset);

  /* 999px境界を跨いだらパネルを畳んでオフセット残留を防ぐ */
  function onHeaderBreakpointChange() {
    closeHeaderMenus(false);
    updateHeaderPanelOffset();
  }
  if (typeof mobileHeaderPanelQuery.addEventListener === 'function') {
    mobileHeaderPanelQuery.addEventListener('change', onHeaderBreakpointChange);
  } else if (typeof mobileHeaderPanelQuery.addListener === 'function') {
    mobileHeaderPanelQuery.addListener(onHeaderBreakpointChange);
  }
})();

/* ============================================
   Cart: Section Rendering API AJAX handler
   ============================================
   theme.js の cart_ajax_enable=false 時に動作。
   数量変更・商品削除を AJAX + Section Rendering API で処理し、
   サーバーレンダリング済み HTML で section 全体を差し替える。
*/
(function() {
  var SECTION_ID = 'cart-template';
  var DEBOUNCE_MS = 500;

  var sectionEl = document.getElementById('shopify-section-' + SECTION_ID);
  if (!sectionEl) return;

  var cartContainer = sectionEl.querySelector('[data-section-type="cart-template"]');
  if (!cartContainer) return;

  var cartRoutes = null;
  try {
    cartRoutes = JSON.parse(document.querySelector('[data-cart-routes]').innerHTML);
  } catch (e) { return; }

  var currentController = null;
  var debounceTimer = null;
  var cartIsUpdating = false;

  function updateCartCount(itemCount) {
    document.querySelectorAll('[data-cart-count]').forEach(function(el) {
      el.textContent = itemCount;
    });
    document.querySelectorAll('[data-cart-count-text-value]').forEach(function(el) {
      el.textContent = itemCount > 0 ? itemCount : '';
    });
    document.querySelectorAll('[data-cart-count-bubble]').forEach(function(el) {
      if (itemCount > 0) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(function(el) {
      if (itemCount > 0) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
    document.querySelectorAll('[data-mobile-cart-guide-count]').forEach(function(el) {
      el.textContent = itemCount;
    });
    document.querySelectorAll('[data-mobile-cart-guide]').forEach(function(el) {
      if (itemCount > 0) {
        el.classList.remove('mobile-cart-guide--hidden');
      } else {
        el.classList.add('mobile-cart-guide--hidden');
      }
    });
  }

  function saveFormState() {
    var state = {};
    var notes = sectionEl.querySelector('[data-cart-notes]');
    if (notes) state.cartNote = notes.value;

    var active = document.activeElement;
    if (active && active.hasAttribute('data-quantity-item')) {
      state.focusQuantityItem = active.getAttribute('data-quantity-item');
      state.focusRole = active.getAttribute('data-role');
    }
    return state;
  }

  function restoreFormState(state) {
    if (state.cartNote !== undefined) {
      var notes = sectionEl.querySelector('[data-cart-notes]');
      if (notes) notes.value = state.cartNote;
    }
    if (state.focusQuantityItem) {
      var selector = '[data-quantity-item="' + state.focusQuantityItem + '"]';
      if (state.focusRole) {
        selector += '[data-role="' + state.focusRole + '"]';
      }
      var target = sectionEl.querySelector(selector);
      if (target) target.focus();
    }
  }

  function setLoading(itemEl, loading) {
    if (!itemEl) return;
    if (loading) {
      itemEl.classList.add('cart__item-panel--loading');
    } else {
      itemEl.classList.remove('cart__item-panel--loading');
    }
  }

  function getCartUpdatingMessage() {
    var message = sectionEl.querySelector('[data-cart-updating-message]');
    if (message) return message;

    var controls = sectionEl.querySelector('.cart__submit-controls');
    if (!controls) return null;

    message = document.createElement('div');
    message.className = 'cart__checkout-blocked cart__checkout-blocked--updating cart__hidden';
    message.setAttribute('data-cart-updating-message', '');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.innerHTML = '<p>カートを更新中です。完了までお待ちください。</p>';

    var checkoutButton = controls.querySelector('[name="checkout"], .gti-checkout-btn');
    controls.insertBefore(message, checkoutButton || controls.firstChild);
    return message;
  }

  function setCheckoutUpdating(updating) {
    cartIsUpdating = updating;

    var message = getCartUpdatingMessage();
    if (message) {
      message.classList.toggle('cart__hidden', !updating);
    }

    sectionEl.querySelectorAll('[name="checkout"], .gti-checkout-btn, .additional-checkout-buttons, a[href$="/checkout"], a[href*="/checkout?"]').forEach(function(element) {
      if (element.hasAttribute('data-cart-updating-message')) return;

      if (updating) {
        if (!element.hasAttribute('data-cart-updating-was-hidden')) {
          element.setAttribute('data-cart-updating-was-hidden', element.classList.contains('cart__hidden') ? 'true' : 'false');
        }
        if (!element.hasAttribute('data-cart-updating-was-disabled')) {
          element.setAttribute('data-cart-updating-was-disabled', element.disabled ? 'true' : 'false');
        }

        element.classList.add('cart__hidden');
        element.setAttribute('aria-hidden', 'true');

        if ('disabled' in element) {
          element.disabled = true;
          element.setAttribute('aria-disabled', 'true');
        }

        var label = element.querySelector('.gti-checkout-label');
        if (label) {
          if (!label.hasAttribute('data-cart-original-label')) {
            label.setAttribute('data-cart-original-label', label.textContent);
          }
          label.textContent = '更新中...';
        }
      } else if (element.hasAttribute('data-cart-updating-was-hidden')) {
        if (element.getAttribute('data-cart-updating-was-hidden') !== 'true') {
          element.classList.remove('cart__hidden');
          element.removeAttribute('aria-hidden');
        }
        if ('disabled' in element && element.getAttribute('data-cart-updating-was-disabled') !== 'true') {
          element.disabled = false;
          element.removeAttribute('disabled');
          element.removeAttribute('aria-disabled');
        }

        var originalLabel = element.querySelector('[data-cart-original-label]');
        if (originalLabel) {
          originalLabel.textContent = originalLabel.getAttribute('data-cart-original-label');
          originalLabel.removeAttribute('data-cart-original-label');
        }

        element.removeAttribute('data-cart-updating-was-hidden');
        element.removeAttribute('data-cart-updating-was-disabled');
      }
    });

    var status = sectionEl.querySelector('[data-cart-status]');
    if (status) {
      status.textContent = updating ? 'カートを更新中です。完了までお待ちください。' : '';
    }
  }

  function cartChange(id, quantity, itemEl) {
    clearTimeout(debounceTimer);
    if (currentController) currentController.abort();
    currentController = new AbortController();

    setCheckoutUpdating(true);
    setLoading(itemEl, true);

    var body = {
      id: id,
      quantity: quantity,
      sections: SECTION_ID,
      sections_url: cartRoutes.cartUrl || '/cart'
    };

    fetch(cartRoutes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: currentController.signal
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart update failed: ' + res.status);
      return res.json();
    })
    .then(function(state) {
      currentController = null;

      var sectionHtml = state.sections && state.sections[SECTION_ID];
      if (!sectionHtml) {
        window.location.reload();
        return;
      }

      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHtml, 'text/html');
      var newSection = doc.getElementById('shopify-section-' + SECTION_ID);
      if (!newSection) {
        window.location.reload();
        return;
      }

      // Capture notes just before DOM swap (not at request start)
      var formState = saveFormState();
      sectionEl.innerHTML = newSection.innerHTML;
      setCheckoutUpdating(false);
      updateCartCount(state.item_count);
      restoreFormState(formState);
      bindEvents();
    })
    .catch(function(err) {
      currentController = null;
      if (err.name === 'AbortError') return;
      setCheckoutUpdating(false);
      setLoading(itemEl, false);
      window.location.reload();
    });
  }

  function handleQuantityChange(evt) {
    var input = evt.target;
    if (!input.hasAttribute('data-quantity-input')) return;

    var itemEl = input.closest('[data-cart-item]');
    if (!itemEl) return;

    var id = itemEl.getAttribute('data-cart-item-key');
    var quantity = parseInt(input.value, 10);
    if (!id || isNaN(quantity) || quantity < 0) return;

    setCheckoutUpdating(true);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      cartChange(id, quantity, itemEl);
    }, DEBOUNCE_MS);
  }

  function handleRemoveClick(evt) {
    var link = evt.target.closest('[data-cart-remove]');
    if (!link) return;
    evt.preventDefault();

    var itemEl = link.closest('[data-cart-item]');
    if (!itemEl) return;

    var id = itemEl.getAttribute('data-cart-item-key');
    if (!id) return;
    cartChange(id, 0, itemEl);
  }

  function bindToggleButton() {
    var btn = sectionEl.querySelector('#toggle-button');
    if (!btn) return;
    btn.addEventListener('click', function() {
      sectionEl.querySelectorAll('.hirakeru').forEach(function(el) {
        el.classList.remove('cart__hidden');
      });
    });
  }

  function handleStepperClick(evt) {
    var btn = evt.target.closest('[data-stepper-minus], [data-stepper-plus]');
    if (!btn) return;

    var stepper = btn.closest('.cart-line__stepper');
    if (!stepper) return;
    var input = stepper.querySelector('[data-quantity-input]');
    if (!input) return;

    var current = parseInt(input.value, 10) || 0;
    var newVal = btn.hasAttribute('data-stepper-minus')
      ? Math.max(0, current - 1)
      : current + 1;

    input.value = newVal;

    // Sync hidden desktop input for form POST compatibility
    var itemEl = stepper.closest('[data-cart-item]');
    if (itemEl) {
      var hiddenInput = itemEl.querySelector('[data-quantity-input-desktop]');
      if (hiddenInput) hiddenInput.value = newVal;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleCartSubmit(evt) {
    if (!cartIsUpdating) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    setCheckoutUpdating(true);
  }

  function handleCheckoutClick(evt) {
    if (!cartIsUpdating) return;

    var target = evt.target.closest('[name="checkout"], .gti-checkout-btn, .additional-checkout-buttons, a[href$="/checkout"], a[href*="/checkout?"]');
    if (!target) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();
    setCheckoutUpdating(true);
  }

  function bindEvents() {
    var container = sectionEl.querySelector('[data-section-type="cart-template"]');
    if (!container) return;

    container.addEventListener('submit', handleCartSubmit, true);
    container.addEventListener('click', handleCheckoutClick, true);
    container.addEventListener('change', handleQuantityChange);
    container.addEventListener('click', handleRemoveClick);
    container.addEventListener('click', handleStepperClick);
    bindToggleButton();
  }

  bindEvents();
})();

/* ============================================
   サポートサイト(info.gateinc.jp)への送客リンク装飾
   ============================================
   来店元ストア(from)と元ページ(back)をクエリで渡し、
   info サイト側の「ストアに戻る」固定バーに使わせる。
   バー本体は WordPress 側スニペット
   (repo: wordpress-info-site/return-to-store.html)が描画する。
*/
(function() {
  var INFO_HOST = 'info.gateinc.jp';
  var storeKey = document.body.dataset.storeKey === 'ip' ? 'ip' : null;
  if (!storeKey) return;

  function decorate(link) {
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return;
    }
    if (url.hostname !== INFO_HOST) return;
    url.searchParams.set('from', storeKey);
    // checkout 等のストア外パスは戻り先にしない
    if (window.location.pathname.indexOf('/checkouts') !== 0) {
      // search も含める(Paywhirl ポータルの ?pw-page= や ?variant= を復元するため)
      if (!url.searchParams.has('back')) {
        var backQuery = new URLSearchParams();
        var variant = new URLSearchParams(window.location.search).get('variant');
        if (variant && /^\d+$/.test(variant)) backQuery.set('variant', variant);
        url.searchParams.set('back', window.location.pathname + (backQuery.size ? '?' + backQuery : ''));
      }
    }
    // ブランドのページ（コレクション・その商品）なら、info の「販売ページに戻る」に「ブランド × ストア名」と出させる
    var brand = (document.body.dataset.infoBrand || '').trim();
    if (brand) {
      url.searchParams.set('brand', brand);
    } else {
      url.searchParams.delete('brand');
    }
    link.href = url.toString();
  }

  function decorateAll() {
    document.querySelectorAll('a[href*="' + INFO_HOST + '"]').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', decorateAll);
  } else {
    decorateAll();
  }

  // The shared product UI emits variantChange before replacing browser history.
  // Keep the actual product path (also on a draft preview), never preview keys.
  document.addEventListener('variantChange', function(event) {
    var variant = event.detail && event.detail.variant;
    document.querySelectorAll('a.info-link').forEach(function(link) {
      var url = new URL(link.href, window.location.href);
      if (url.protocol !== 'https:' || url.hostname !== INFO_HOST) return;
      var backPath = (url.searchParams.get('back') || '').split('?')[0];
      if (backPath.indexOf('/products/') !== 0) return;
      var variantId = variant && String(variant.id);
      url.searchParams.set('back', backPath + (variantId && /^\d+$/.test(variantId) ? '?variant=' + variantId : ''));
      link.href = url.toString();
    });
  });

  // カート section の AJAX 差し替え等で後から入ったリンクはクリック時に補正する
  ['click', 'auxclick'].forEach(function(type) {
    document.addEventListener(type, function(event) {
      var link = event.target.closest && event.target.closest('a[href*="' + INFO_HOST + '"]');
      if (link) decorate(link);
    }, true);
  });
})();
